import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { Shop } from '@/types/shop';

import type { ShopUserRole } from './shop';

export interface ShopsState {
  shops: Shop[];
  selectedShopId: string | null;
  apiKey: string | null;
  role: ShopUserRole | null;
}

interface StateWithShops {
  shops: ShopsState;
}

const initialState: ShopsState = {
  shops: [],
  selectedShopId: null,
  apiKey: null,
  role: null,
};

const shopsSlice = createSlice({
  name: 'shops',
  initialState,
  reducers: {
    setShops(state, action: PayloadAction<Shop[]>) {
      state.shops = action.payload;
    },
    setSelectedShopId(state, action: PayloadAction<string | null>) {
      state.selectedShopId = action.payload;
    },
    setApiKey(state, action: PayloadAction<string | null>) {
      state.apiKey = action.payload;
    },
    clearShopSession(state) {
      state.selectedShopId = null;
      state.apiKey = null;
      state.role = null;
    },

    switchShopComplete(
      state,
      action: PayloadAction<{
        shopId: string;
        apiKey: string | null;
        role: ShopUserRole | null;
        refreshToken?: string | null;
      }>,
    ) {
      const { shopId, apiKey, role } = action.payload;
      state.selectedShopId = shopId;
      state.apiKey = apiKey;
      state.role = role;
    },
  },
});

export const { clearShopSession, setShops, setSelectedShopId, setApiKey, switchShopComplete } =
  shopsSlice.actions;

export const selectShops = (state: StateWithShops) => state.shops.shops;
export const selectSelectedShopId = (state: StateWithShops) => state.shops.selectedShopId;
export const selectSelectedShopRole = (state: StateWithShops) => state.shops.role;

export default shopsSlice.reducer;
